module.exports = __webpack_public_path__ + "img/logo_g.1d5c59a2.png";